module.exports = __webpack_public_path__ + "img/ah-iso.ba2250ed.svg";